import { atom } from 'recoil';

/** Advisory presence of OTHER editors on the loaded patient. */
export interface OtherEditorsPresence {
    /** Viewer sessions (besides this one) with the patient open. */
    readonly count: number;
    /** Of those, how many reported unsaved changes on their last beat. */
    readonly editing: number;
}

/**
 * OTHER editors currently on the loaded patient, from the advisory
 * presence registry (see useEditorPresence — not a lock; the save
 * workflow's optimistic concurrency is the real protection). Refreshed
 * on every presence heartbeat, so joins surface within one beat (15 s)
 * and leaves within the server TTL. All-zero when alone, when no patient
 * is loaded, or when presence is unavailable.
 */
export const otherEditorsPresenceState = atom<OtherEditorsPresence>({
    key: 'otherEditorsPresence',
    default: { count: 0, editing: 0 },
});
